import { render, staticRenderFns } from "./SiteFooter.vue?vue&type=template&id=0672af60&scoped=true&"
import script from "./SiteFooter.vue?vue&type=script&lang=ts&"
export * from "./SiteFooter.vue?vue&type=script&lang=ts&"
import style0 from "./SiteFooter.vue?vue&type=style&index=0&id=0672af60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0672af60",
  null
  
)

export default component.exports